module.exports = __webpack_public_path__ + "img/sdg12_id.ab6f0e7b.svg";